import { activeDeviceChangeListener } from 'features/user-media/listeners/activeDeviceChangeListener';
import { AppStartListening } from 'store/listenerMiddleware';
import { audioOutputDeviceChangeListener } from 'features/user-media/listeners/audioOutputDeviceChangeListener';

export const addMediaDeviceListeners = (startListening: AppStartListening) => {
  activeDeviceChangeListener(startListening);
  audioOutputDeviceChangeListener(startListening);
};
